import {combineReducers} from "redux";
import authReducer from "../features/auth/auth.slice";
import approvementRequestReducer from "../features/approvement/approvement.slice";
import avilabilityReducer from "../features/availability/availability.slice";
import billReducer from "../features/bill/bill.slice";
import linkReducer from "../features/link/link.slice";
import menuReducer from "../features/menu/menu.slice";
import menuItemReducer from "../features/menuItem/menuItem.slice";
import paymentReducer from "../features/payment/payment.slice";
import quidReducer from "../features/quid/quid.slice";
import restaurantReducer from "../features/restaurant/restaurant.slice";
import sessionReducer from "../features/session/session.slice";
import walletReducer from "../features/wallet/wallet.slice";

const rootReducer = combineReducers({
    approvementRequest: approvementRequestReducer,
    auth: authReducer,
    availability: avilabilityReducer,
    bill: billReducer,
    link: linkReducer,
    menu: menuReducer,
    menuItem: menuItemReducer,
    payment: paymentReducer,
    quid: quidReducer,
    restaurant: restaurantReducer,
    session: sessionReducer,
    wallet: walletReducer
});

export default rootReducer;

